/**
 * Recurring Payment Rule domain entity
 * Represents a subscription or recurring payment configuration
 */
/**
 * Status of a recurring payment rule
 * Maps to backend RecurringPaymentRuleStatus enum
 */
export var RecurringPaymentRuleStatus;
(function (RecurringPaymentRuleStatus) {
    RecurringPaymentRuleStatus["PendingToken"] = "PendingToken";
    RecurringPaymentRuleStatus["Active"] = "Active";
    RecurringPaymentRuleStatus["Pending"] = "Pending";
    RecurringPaymentRuleStatus["PaymentCreated"] = "PaymentCreated";
    RecurringPaymentRuleStatus["PendingExecute"] = "PendingExecute";
    RecurringPaymentRuleStatus["Completed"] = "Completed";
    RecurringPaymentRuleStatus["Failed"] = "Failed";
    RecurringPaymentRuleStatus["Paused"] = "Paused";
    RecurringPaymentRuleStatus["Cancelled"] = "Cancelled";
})(RecurringPaymentRuleStatus || (RecurringPaymentRuleStatus = {}));
/**
 * Frequency of recurring payments
 * Maps to backend RecurringPaymentFrequency enum
 */
export var RecurringPaymentFrequency;
(function (RecurringPaymentFrequency) {
    RecurringPaymentFrequency["Monthly"] = "Monthly";
    RecurringPaymentFrequency["Quarterly"] = "Quarterly";
    RecurringPaymentFrequency["SemiAnnual"] = "SemiAnnual";
    RecurringPaymentFrequency["Annual"] = "Annual";
})(RecurringPaymentFrequency || (RecurringPaymentFrequency = {}));
